import FooterLogo from '../assets/images/logo-footer.svg';
import './Footer.css';
import { LuPhoneCall } from "react-icons/lu";
import { MdOutlinePlace } from "react-icons/md";
import { TbMailDown } from "react-icons/tb";

const Footer = () => {
    return (
        <footer className="footer" id="contact_us">
            <div className="container text-center">
                <div className="container lg:flex md:flex lg:justify-between gap-4 h-100 border-bottom border-white">
                    <div className="">
                        <img src={FooterLogo} alt="footer logo" color="footer-logo" className="my-2" />
                        <p className="text-end text-white text-sm">
                            استفاده از چت‌یار به عنوان یک ابزار نوآورانه، می‌تواند محدودیت‌های روش‌های سنتی ارتباطی
                            مانند تماس تلفنی، سیستم تیکتینگ، ایمیل و مراجعه حضوری را پشت سر بگذارد و به سازمان‌ها
                            کمک کند تا با مشتریان خود ارتباطی پایدار و مؤثر برقرار کنند.
                        </p>
                    </div>
                    <div className="w-100 my-auto">
                        <div className="d-flex text-white my-3">
                            <LuPhoneCall color="white" size={30} className="my-auto" />
                            <p className="my-auto mx-2">۹۸−۹۹۱۵۳۸۱۲۳۸+</p>
                        </div>
                        <div className="d-flex text-white my-3">
                            <MdOutlinePlace color="white" size={30} className="my-auto" />
                            <div>
                                <p className="my-auto mx-2 text-start">
                                    دفتر ۱ : بلوار آفریقا، خیابان تابان غربی، پلاک ۱۳، طبقه اول
                                </p>
                                <p className="my-auto mx-2 text-start">
                                    دفتر ۲ : دانشگاه علم و صنعت، دانشکده کامپیوتر، طبقه دوم
                                </p>
                            </div>
                        </div>
                        <div className="d-flex text-white my-3">
                            <TbMailDown color="white" size={30} className="my-auto" />
                            <p className="my-auto mx-2">
                                info@dadmatech.ir
                            </p>
                        </div>
                    </div>
                </div>

                {/* Enamad Trust Seal */}
                <div className="contain text-center mt-4 mr-4" style={{ width: '120px' }}>
                    <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=581044&Code=uxQa6TJGgLOHS5k4TStbszb0EpQipBYN">
                        <img referrerPolicy="origin"
                            src="https://trustseal.enamad.ir/logo.aspx?id=581044&Code=uxQa6TJGgLOHS5k4TStbszb0EpQipBYN"
                            alt=""
                            style={{ cursor: 'pointer' }}
                            code="uxQa6TJGgLOHS5k4TStbszb0EpQipBYN"
                            loading='lazy'
                        />
                    </a>
                </div>
            </div>

            <div className="mt-3 mb-5 text-center">
                <p className="text-white my-auto">
                    تمام حقوق این سایت برای شرکت هوش مصنوعی <a className='text-decoration-none text-white' href="https://dadmatech.ir">دادماتک</a> محفوظ است.
                </p>
            </div>
        </footer>
    );
}

export default Footer;
